import { IDetailedUserInfo } from "./IDetailedUserInfo";
import { IPurchaseInfo } from "./IPurchaseInfo";
import { ModoomapEvent } from "./ModoomapEvent";
import userInfo from "./process=getinfo";
import purchaseInfo from "./process=purchaselist";

/**
 * @author sukim91
 * @date 2022-10-06 14:37
 * @remark MyPageHelper
 * @props None
 */
export class MyPageHelper {
    /** @returns Promise<IDetailedUserInfo> */
    public async getDetailedUserInfo() {
        // 쿠키 이슈로 임시 json 사용
        /*
        let result : Promise<IDetailedUserInfo> | null = null;

        const url = `https://modoomap.com/user?process=getinfo`;

        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });

        if (res.status === 200) {
            result = res.json();
        } else {
            console.error(`url: ${url}, statusCode: ${res.status}`);
        }
        */
        
        const promise = new Promise<IDetailedUserInfo>((resolve) => {
            // 관리자 계정
            const result : IDetailedUserInfo = userInfo(0);

            resolve(result);
        });

        return promise;
    }

    /** @returns Promise<IPurchaseInfo> */
    public async getPurchaseInfo() {
        // 쿠키 이슈로 임시 json 사용
        /*
        let result : Promise<IPurchaseInfo> | null = null;

        const url = `https://modoomap.com/user?process=purchaselist`;

        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });

        if (res.status === 200) {
            result = res.json();
        } else {
            console.error(`url: ${url}, statusCode: ${res.status}`);
        }
        */

        const promise = new Promise<IPurchaseInfo>((resolve) => {
            const result : IPurchaseInfo = purchaseInfo(0);

            resolve(result);
        });

        return promise;
    }

    /** void */
    public onHandleEvent(event : ModoomapEvent, any : any) {

    }
}